import { render, staticRenderFns } from "./MyOrderForm.vue?vue&type=template&id=588d8642&scoped=true&"
import script from "./MyOrderForm.vue?vue&type=script&lang=js&"
export * from "./MyOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderForm.vue?vue&type=style&index=0&id=588d8642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d8642",
  null
  
)

export default component.exports